import styled from "styled-components/macro";
import { rem } from "polished";
import Info from "../../../components/Info";
import SupportServices from "../../../components/SupportServices";
import media from "../../../theme/media";

function Supports() {
    return (
        <Support>
            <SupportInner>
                <h2>Family violence support services</h2>
                <p>
                If you need help completing this application, contact your{" "}
                <Info
                    displayText="local court"
                    headingText="nearest court"
                    bodyText='<a href="https://www.mcv.vic.gov.au/going-court/find-court" title="_blank" rel="noopener noreferrer" >You can find your nearest court location here.</a>'
                    inherit
                />{" "}
                or{" "}
                <Info
                    displayText="family violence support service"
                    headingText="family violence support service"
                    bodyText='<a href="https://www.dvrcv.org.au/support-services/victorian-services" title="_blank" rel="noopener noreferrer" >Family violence support services</a>'
                    inherit
                />{" "}
                or one of the following state-wide services:
                </p>

                <br />
                 <SupportServices
                    services={[
                    "theOrangeDoor",
                    "safeSteps",
                    "noToViolence",
                    "_1800Respect",
                    "umalekBalitProgram",
                    "djirraLegal",
                    "dardiMunwurro",
                    "inTouch",
                    "rainbowDoor",
                    "sexualAssaultServicesVictoria"
                    ]}
                />
                <h2>Legal advice</h2>
                <SupportServices
                    services={[
                    "victoriaLegalAid",
                    "federationOfCommunityLegalCentres",
                    "victoriaAboriginalLegalService",
                    "djirra",
                    "womensLegalServiceVictoria",
                    "qLaw",
                    "refugeeLegal",
                    "seniorsRightsVictoria",
                    "villamantaDisabilityRightsLegalCentre",
                    "youthlawVictoria",
                    ]}
                />
            </SupportInner>
        </Support>
    );
}

export default Supports;

const leftPaddingTablet = "15px";

const Support = styled.div`
  padding: 0 15px 70px;
  padding-top: 0px;
  width: 100%;
  max-width: 1310px;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 0 auto;

  ${media.greaterThan("desktop")`
      justify-content: flex-start;
    `}
`;

const SupportInner = styled.div`
  background: white;
  position: relative;
  width: 100%;
  max-width: 800px;
  margin-top: 20px;

  ${media.greaterThan("tablet")`
      margin-top: 0px;
      padding-left: ${leftPaddingTablet};
  `};

  ${media.greaterThan("desktop")`
    padding-left: 105px;
    transform: translateY(-40px);
  `};

  p {
    font-size: ${rem(18)};
  }
`;







